<template>
  <loader v-if="loading" :stretch="true" :inverse="true" />
  <template v-else>
    <StudentChoiceHeader :style="themeStyle" />
    <div class="page" :style="themeStyle">
      <div class="ad">
        <h1 v-if="error && !externalLink">Something has gone wrong.</h1>
        <slot v-else name="ad"></slot>
      </div>
      <div class="ad-banner-left-nav"></div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </template>
</template>
<script lang="ts">
import useFormatter from "@/use/formatter";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { mapActions, mapGetters, mapState } from "vuex";
import { $api } from "@/services/api";
import Loader from "@/components/shared/Loader.vue";
import StudentChoiceHeader from "@/components/shared/layout/Header.vue";

export default defineComponent({
  props: {
    externalLink: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const route = useRoute();
    const { formatHexToRgb } = useFormatter();
    return { formatHexToRgb, route };
  },
  components: { Loader, StudentChoiceHeader },
  data: () => ({
    loading: true,
    error: false,
  }),
  computed: {
    ...mapGetters(["cuLogoUrl"]),
    ...mapState(["lenderData"]),
    themeStyle(): any {
      // SA color: #f7941e
      // Default Green: #01675a
      const themeRgb = this.formatHexToRgb(this.lenderData?.primaryColor);
      const secondaryRgb = this.formatHexToRgb(this.lenderData?.secondaryColor);
      return {
        "--theme-color": this.lenderData?.primaryColor,
        "--theme-color-rgb": `${themeRgb?.r}, ${themeRgb?.g}, ${themeRgb?.b}`,
        "--secondary-color": this.lenderData?.secondaryColor,
        "--secondary-color-rgb": `${secondaryRgb?.r}, ${secondaryRgb?.g}, ${secondaryRgb?.b}`,
      };
    },
  },
  methods: {
    ...mapActions(["setDefaultLender", "setLenderData"]),
  },
  async mounted() {
    // need endpoint that specifically only returns the lender branding
    const query = this.route.query as any;
    if (this.lenderData === undefined) {
      let lid = query.lid || query.LID || 0;

      if (lid === 0) {
        lid = localStorage.getItem("slc-lid") || 0;
      }

      const lenderConfig = await $api.configuration.getLenderConfigurationByLenderId(lid);
      if (!lenderConfig.error || lenderConfig.lid) {
        await this.setLenderData(lenderConfig);
        localStorage.setItem("slc-lid", lid);
      } else {
        this.error = true;
        await this.setDefaultLender();
      }
    }
    this.loading = false;
  },
});
</script>
<style src="@/styles/page.scss" lang="scss" />
